import React from "react"
import { Route, Routes } from "react-router-dom"
import { ReportFilterContextProvider } from "../context/ReportFilterContext"
import NotFound from "../features/notFound/pages/NotFound"
import GenerateReport from "../features/reports/pages/GenerateReport"
import { ReportHistory } from "../features/reports/pages/ReportHistory"
import Preview from "../features/reports/pages/components/EnergyReportComponents/PreviewScreen"

export const ReportRoutes = () => {
    return (
    <ReportFilterContextProvider>
        <Routes>
          <Route path="history" element={<ReportHistory />} />
          <Route path="generate" element={<GenerateReport />} />
          <Route path="preview-report" element={<Preview />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ReportFilterContextProvider>)
}